// damaged/index.vue
export const defaultDamagedListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null,
}

// gs_flow/history.vue
export const defaultGsFlowHistoryListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

// gs_flow/index.vue
export const defaultGsFlowListQuery = {
    pageNum: 1,
    pageSize: 15,
    type: 1,
    keyword: null,
}

// gs_flow/index.vue
// smith_work/components/give_or_return_form.vue
// smith_work/components/out_return_form.vue (shared — identical shape)
export const defaultGsFlow = {
    id: null,
    gsItnxNo: null,
    reference: null,
    type: 1,
    version: 1,
    place: null,
    fromUserId: null,
    fromUserName: "",
    toUserId: null,
    toUserName: "",
    io: 1,
    of: 1,
    customerName: null,
    itnxNo: null,
    lotNo: null,
    productId: null,
    sku: null,
    description: null,
    categoryId: null,
    parentCategoryId: null,
    categoryName: "",
    quality: "",
    note: "",
    qty: 1,
    qtyUnit: 1,
    wt: 0,
    wtUnit: 3,
    wtStr: "",
    gram: 0,
    point: 0,
    density: 0,
    wtLoss: 0,
    wtStrLoss: "",
    wtAkhout: 0,
    wtStrAkhout: "",
    wtAlloy: 0,
    wtStrAlloy: "",
    wtBaw: 0,
    wtStrBaw: "",
    wtTotal: 0,
    wtStrTotal: "",
    qtyBalance: null,
    wtBalance: 0,
    wtStrBalance: "",
    balanceStatus: 1,
    sort: 100,
    crudStatus: 2,
    createdAt: null,
    lastUpdate: null,
    employeeId: null,
    employeeName: "",
    inventoryType: 2
}

// gs_flow/components/GsFlowFormDialog.vue
export const defaultGsFlowRawWt = {
    totalK: null, totalP: null, totalY: null, totalG: null,
    lossK: null, lossP: null, lossY: null, lossG: null,
    akhoutK: null, akhoutP: null, akhoutY: null, akhoutG: null,
    alloyK: null, alloyP: null, alloyY: null, alloyG: null,
    bawK: null, bawP: null, bawY: null, bawG: null,
    totalWtK: null, totalWtP: null, totalWtY: null, totalWtG: null,
}

// pro_item_transaction/history.vue
export const defaultProItemTransactionHistoryListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

// pro_item_transaction/index.vue
export const defaultProItemTransactionListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null,
    reference: null,
    sku: null,
    inItnx: null,
    outItnx: null
}

// smith/details.vue
export const defaultSmithDetails = {
    id: null,
    name: null,
    nameCode: null,
    username: null,
    email: null,
    phone: null,
    address: null,
    remark: null,
    status: 1,
}

export const defaultSmithWorkQuery = {
    pageNum: 1,
    pageSize: 15,
    swType: null,
}

export const defaultDamagedQuery = {
    pageNum: 1,
    pageSize: 15,
    smithId: null,
}

// smith/index.vue
export const defaultSmithListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

export const defaultSmith = {
    email: null,
    icon: null,
    id: null,
    name: null,
    nameCode: null,
    password: null,
    phone: null,
    address: null,
    remark: null,
    status: 1,
    username: null,
    countIndex: 0,
}

// smith_work/components/out_form.vue
export const defaultSmithWorkOut = {
    id: null,
    gsCode: null,
    pic: null,
    imageFile: null,
    tovId: null,
    tovNo: null,
    type: 1,
    status: 1,
    estimation: 1,
    assignedDate: null,
    particular: null,
    note: null,
    design: null,
    nameCode: null,
    wtUnit: null,
    wtIn: null,
    wtInStr: null,
    wtOut: null,
    wtOutG: null,
    wtOutStr: null,
    wtLoss: null,
    wtLossG: null,
    wtLossStr: null,
    wtPayLoss: null,
    wtPayLossStr: null,
    wtSaved: null,
    wtSavedStr: null,
    wtGem: null,
    wtGemG: null,
    wtGemStr: null,
    wtNet: null,
    wtNetStr: null,
    smithId: null,
    smithName: "",
    customerId: null,
    customerName: null,
    employeeId: null,
    employeeName: null,
    gram: 0,
    point: 0,
    density: 0,
}

// smith_work/components/out_return_form.vue
export const defaultLostDamaged = {
    id: null,
    gsCode: null,
    smithId: null,
    smithName: "",
    sku: null,
    categoryId: null,
    parentCategoryId: null,
    categoryName: "",
    qty: 1,
    qtyUnit: 1,
    wt: 0,
    wtUnit: 3,
    wtStr: "",
}

// smith_work/components/smith_work_form.vue
export const defaultSmithWorkForm = {
    id: null,
    gsCode: null,
    tovId: null,
    tovNo: null,
    type: 1,
    status: 1,
    estimation: 1,
    assignedDate: null,
    particular: null,
    wtUnit: 3,
    wtIn: null,
    wtInStr: null,
    wtInG: null,
    note: null,
    design: null,
    nameCode: null,
    smithId: null,
    smithName: "",
    tmpLotNo: null,
    customerId: null,
    customerName: null,
    employeeId: null,
    employeeName: null
}

// smith_work/details.vue
export const defaultSmithWorkDetails = {
    id: null,
    gsCode: null,
    pic: null,
    imageFile: null,
    tovId: null,
    tovNo: null,
    type: 1,
    status: 1,
    estimation: 1,
    assignedDate: null,
    particular: null,
    note: null,
    design: null,
    nameCode: null,
    wtUnit: null,
    wtIn: null,
    wtInStr: null,
    wtOut: null,
    wtOutG: null,
    wtOutStr: null,
    wtLoss: null,
    wtLossG: null,
    wtLossStr: null,
    wtPayLoss: null,
    wtPayLossStr: null,
    wtSaved: null,
    wtSavedStr: null,
    wtGem: null,
    wtGemG: null,
    wtGemStr: null,
    smithId: null,
    smithName: "",
    customerId: null,
    customerName: null,
    employeeId: null,
    employeeName: null
}

// smith_work/history.vue
export const defaultSmithWorkHistoryListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

// smith_work/index.vue
export const defaultSmithWorkListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null,
}

// tov/index.vue
export const defaultTovListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null,
}

export const defaultTov = {
    id: null,
    pic: null,
    finalUpload: null,
    imageFile: null,
    tovNo: null,
    orderItemRefNo: null,
    ofType: 1,
    appointment: null,
    place: null,
    customerId: null,
    customerName: null,
    qty: 1,
    qtyUnit: 1,
    categoryId: null,
    parentCategoryId: null,
    categoryName: null,
    quality: null,
    design: null,
    note: null,
    rateType: 2,
    usdRate: null,
    goldRate: null,
    rateNote: null,
    employeeId: null,
    employeeName: null,
}

// tov/tov_history.vue
export const defaultTovHistoryListQuery = {
    pageNum: 1,
    pageSize: 15,
    keyword: null
}

// smith_work/components/give_or_return_form.vue
export const defaultGiveOrReturnRawWt = {
    totalK: null, totalP: null, totalY: null, totalG: null,
    balanceK: null, balanceP: null, balanceY: null, balanceG: null,
    lossK: null, lossP: null, lossY: null, lossG: null,
    akhoutK: null, akhoutP: null, akhoutY: null, akhoutG: null,
    alloyK: null, alloyP: null, alloyY: null, alloyG: null,
    bawK: null, bawP: null, bawY: null, bawG: null,
}

// smith_work/components/out_form.vue
export const defaultOutFormRawWt = {
    outK: null, outP: null, outY: null, outG: null,
    lossK: null, lossP: null, lossY: null, lossG: null,
    payLossK: null, payLossP: null, payLossY: null, payLossG: null,
    savedK: null, savedP: null, savedY: null, savedG: null,
    gemK: null, gemP: null, gemY: null, gemG: null,
    netK: null, netP: null, netY: null, netG: null,
}

// smith_work/components/out_return_form.vue
export const defaultOutReturnRawWt = {
    oldLossK: null, oldLossP: null, oldLossY: null, oldLossG: null,
    outReturnK: null, outReturnP: null, outReturnY: null, outReturnG: null,
    newLossK: null, newLossP: null, newLossY: null, newLossG: null,
    wtK: null, wtP: null, wtY: null, wtG: null,
}

// tov/components/tov_misc_form.vue
export const defaultTovMiscRawWt = {
    cusK: null, cusP: null, cusY: null,
    voucherK: null, voucherP: null, voucherY: null
}

// tov/components/tov_stock_info_form.vue
export const defaultTovStockInfoRawWt = {
    totalK: null, totalP: null, totalY: null,
    lossK: null, lossP: null, lossY: null,
    gemK: null, gemP: null, gemY: null,
    netK: null, netP: null, netY: null,
    totalG: null, lossG: null, lossPc: null,
    gemG: null, netG: null
}
